import { render, staticRenderFns } from "./Vaardigheden.vue?vue&type=template&id=6417aaf6&"
import script from "./Vaardigheden.vue?vue&type=script&lang=js&"
export * from "./Vaardigheden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports